import { version } from '../package.json'
import { getPageViewSize } from './util/screen';
import { commitid, gitOriginUrl } from './constants';

/**
 * 用于 sdk 本身异常的上报
 * @description 为了避免 sdk 本身异常上报到用户的华佗应用，所以写死报到专门的应用里
 * 华佗应用链接：
 * 学科 1005033: http://huatuo.xesv5.com/htmonitor/app/web/#/huatuo/board/10638?tabkey=basic&filte_dimension=1&filter_date=2022-04-30%2000%3A00%3A00%2C2022-05-06%2017%3A00%3A00
 * 素质 1005034: http://huatuo.xesv5.com/htmonitor/app/web/#/huatuo/board/10639?tabkey=basic&filte_dimension=1&filter_date=2022-04-30%2000%3A00%3A00%2C2022-05-06%2017%3A00%3A00
 * @param {Error} error - JS 错误对象
 * @param {String} baseURL - 用户配置的 baseURL，日志上报接口的基础域名和路径
 * @returns void
 */
export function postSdkOwnError (error, baseURL) {
  if (!baseURL) return
  const nowTimestamp = Date.now()
  const referer = 'fe_log_sdk.npm.xesv5.com'
  const api = `${baseURL}c.gif`
  // WARN 通过域名区分素质和学科，如果域名变了这里的逻辑可能会受影响
  // 日志中心应用链接：
  // 学科 1005033: https://cloud.tal.com/logcenter#/service/detail?id=5406
  // 素质 1005034: https://cloud.tal.com/logcenter#/service/detail?id=5407
  const appid = api.indexOf('xesimg') > -1 ? '1005034' : '1005033'
  const eventid = 'fe_log_sdk'
  const ua = navigator.userAgent
  // 上报内容字段参考了 sdk js 运行时异常数据结构
  const content = {
    data: {
      mode: 'stack',
      name: error.name,
      stack: [{ context: [error.stack] }],
      type: 'Script',
      effectiveType: navigator?.connection?.effectiveType || '',
      pageviewsize: getPageViewSize(),
      commitid,
      gitOriginUrl,
      msg: error.message,
      currenthref: window.location.href,
      rsd: ua,
      eventid,
      extracommon: {
        eventid
      }
    },
    pageid: document.title,
    ua,
    appid,
    version,
    accessMode: '__accessMode__'
  }

  const xhr = new XMLHttpRequest() // eslint-disable-line
  xhr.open('POST', api)
  xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8')
  xhr.setRequestHeader('x-log-appid', appid)
  xhr.setRequestHeader('x-log-referer', referer)
  xhr.setRequestHeader('x-log-timestamp', `${nowTimestamp}`)
  xhr.send(`content=${JSON.stringify([content])}`)
}
